<div class="loader-row-wrapper">
  <img image-src class="loader" src="{{assetsPath}}loading.svg" alt="loading-icon" />
</div>
